import { render, staticRenderFns } from "./PageRegisterComplete.vue?vue&type=template&id=1ca16268&scoped=true&"
import script from "./PageRegisterComplete.vue?vue&type=script&lang=js&"
export * from "./PageRegisterComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca16268",
  null
  
)

export default component.exports